<template>
  <div class="menuDiv page-menu">
    <div class="my-inbox" ref="box">
      <div class="navDiv">
        <div class="navDivList" style="margin-left: .2rem;">
          <a href="/myyq">
            <div class="navImg">
              <img src="../../assets/yuanqu.jpg" />
            </div>
            <div class="txt">
              墓园园区
            </div>
          </a>
        </div>
        <div class="navDivList">
          <a href="/beixing">
            <div class="navImg">
              <img src="../../assets/home21.jpg" />
            </div>
            <div class="txt"><i class="iconfont" style="color:#ff0000;">&#xe646;</i>碑型推荐</div>
          </a>
        </div>
        <div class="navDivList">
          <a href="/jdz">
            <div class="navImg">
              <img src="../../assets/jiedi.jpg" />
            </div>
            <div class="txt">
              节地生态葬
            </div>
          </a>
        </div>
        <div class="navDivList">
          <a href="/byyw">
            <div class="navImg">
              <img src="../../assets/byyw_.png" />
            </div>
            <div class="txt">
              殡仪业务
            </div>
          </a>
        </div>
        <div class="navDivList">
          <a href="/sqqy">
            <div class="navImg">
              <img src="../../assets/sqqy_.png" />
            </div>
            <div class="txt">
              生前契约
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lz-menu',
}
</script>

<style>
.menuDiv {
  width: 100%;
}
.menuDiv .my-inbox {
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100%;
  white-space: nowrap;
}
.menuDiv .item {
  display: inline-block;
  height: 2rem;
  line-height: 2rem;
  margin: 0.5rem;
  padding: 0px 0.8rem;
  text-align: center;
  color: red;
}
.menuDiv .active {
  background-color: #036875;
  font-weight: bold;
  border-radius: 25px;
  color: #fff;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.page-menu .navDiv {
  display: flex;
  margin-top: 1.6rem;
  height: unset !important;
}
.page-menu .navImg {
  height: 3rem;
}
.page-menu .navDivList {
  margin-right: 0.53rem;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.16rem;
  overflow: hidden;
}
.page-menu .navDivList .txt {
  text-align: center;
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
  line-height: 0.53rem;
}
.page-menu .navDivList img {
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 0.16rem;
  overflow: hidden;
  margin-bottom: 0.27rem;
}
</style>
